import React from 'react';
import { MDBFooter, MDBContainer, MDBRow, MDBCol, MDBIcon } from 'mdb-react-ui-kit';

export default function Footer() {
  return (
    <MDBFooter bgColor='light' className='text-center text-lg-start text-muted'>
      <section className='d-flex justify-content-center justify-content-lg-between p-4 border-bottom'>
       
        <div>
          <a href='' className='me-4 text-reset'>
            <MDBIcon fab icon="facebook-f" />
          </a>
          <a href='' className='me-4 text-reset'>
            <MDBIcon fab icon="twitter" />
          </a>
          <a href='' className='me-4 text-reset'>
            <MDBIcon fab icon="google" />
          </a>
          <a href='' className='me-4 text-reset'>
            <MDBIcon fab icon="instagram" />
          </a>
          <a href='' className='me-4 text-reset'>
            <MDBIcon fab icon="linkedin" />
          </a>
          <a href='' className='me-4 text-reset'>
            <MDBIcon fab icon="github" />
          </a>
        </div>
      </section>

      <section className=''>
        <MDBContainer className='text-center text-md-start mt-5'>
          <MDBRow className='mt-3'>
            <MDBCol md="3" lg="4" xl="3" className='mx-auto mb-4'>
              <h6 className='text-uppercase fw-bold mb-4'>
                <MDBIcon icon="gem" className="me-3" />
                VOLUNTEER APP
              </h6>
              <p>
                Програма розроблена студентом 4 курсу групи КН19002б - Студіградом Іллею Вадимовичем.
              </p>
              <p>
              Керівник дипломного проекту - Кузьмінська Олена Геронтіївна
              </p>
              
            </MDBCol>

            <MDBCol md="2" lg="2" xl="2" className='mx-auto mb-4'>
              <h6 className='text-uppercase fw-bold mb-4'>Технології</h6>
              <p>
                <a href='#!' className='text-reset'>
                  NODE JS
                </a>
              </p>
              <p>
                <a href='#!' className='text-reset'>
                  React
                </a>
              </p>
              <p>
                <a href='#!' className='text-reset'>
                  MYSQL
                </a>
              </p>
              <p>
                <a href='#!' className='text-reset'>
                  GIT
                </a>
              </p>
            </MDBCol>

            <MDBCol md="3" lg="2" xl="2" className='mx-auto mb-4'>
              <h6 className='text-uppercase fw-bold mb-4'>Корисні посилання</h6>
              <p>
                <a href='/search' className='text-reset'>
                  Карта
                </a>
              </p>
              <p>
                <a href='/forum' className='text-reset'>
                  Форум
                </a>
              </p>
              <p>
                <a href='/information' className='text-reset'>
                  Інформація про перевезення
                </a>
              </p>
              <p>
                <a href='#!' className='text-reset'>
                  Help
                </a>
              </p>
            </MDBCol>

            <MDBCol md="4" lg="3" xl="3" className='mx-auto mb-md-0 mb-4'>
              <h6 className='text-uppercase fw-bold mb-4'>Контакти</h6>
              <p>
                <MDBIcon icon="home" className="me-2" />
                  Ukraine , Brovary , Kyiv
              </p>
              <p>
                <MDBIcon icon="envelope" className="me-3" />studigradilya@gmail.com
              </p>
              <p>
                <MDBIcon icon="phone" className="me-3" />+ 380 98 876 35 18
              </p>
              <p>
                <MDBIcon icon="print" className="me-3" />+ 01 234 567 89
              </p>
            </MDBCol>
          </MDBRow>
        </MDBContainer>
      </section>

      <div className='text-center p-4' style={{ backgroundColor: 'rgba(0, 0, 0, 0.05)' }}>
        © 2023 Copyright:
        <a className='text-reset fw-bold' href='https://mdbootstrap.com/'>
          studigradilya@gmail.com
        </a>
      </div>
    </MDBFooter>
  );
}